function TheGame() {
    /*////////////////////////////////////////////////////////////////////////////////
//standard game logic
     */
    this.gameId = _ndok_app_id;
    this.backgroundcolor = 0x9c96a0;
    this.positionGameItems = positionGameItems;
    this.initGame = initGame;
    this.resetGame = resetGame;
    this.stopGame = stopGame;
    this.startGame = startGame;
    this.cycleGame = cycleGame;
    var gameData = {};
    this.gameData = gameData;
    var sprites;

    var counter;


    var itemsPositionsObject = { drop_area: { x: 175, y: 54, w: 405, h: 500, n: "drop_area" }, coda: { x: 750, y: 197, w: 131, h: 204, n: "coda" }, zebra: { x: 222, y: 103, w: 273, h: 411, n: "zebra" } };
    /**
     * CORE GAME LOGIC
     */
    function initGame() {
        sprites = game.sprites;

        positionGameItems();

        makeScenes();
        // makeCounter();
        document.addEventListener(GameEvents.ANSWER_OK, onAnswerOk, true);
        document.addEventListener(GameEvents.ANSWER_WRONG, onAnswerWrong, true);
        document.addEventListener(GameEvents.EVENT_START_GAME, onStartGame, true);
        document.addEventListener('stopGame', onStopGame, true);
    }



    function resetGame() {
        resetItems();
        prepareData();
    }

    function startGame() {

        scenesContainer.removeChildren(0, scenesContainer.children.length);
        scenesContainer.addChild(gameData.scene.container);
        //   counter.setText(gameData.currentItem + "/" + gameData.numItems);
        cycleGame();
    }

    function onStartGame() {

    }

    function onStopGame() {
        end();
    }

    function cycleGame() {

        if (gameData.currentItem < gameData.numItems) {
            renderer.view.dispatchEvent(new Event(GameEvents.EVENT_CYCLE_GAME));
        } else {

            setTimeout(end, 1600);
        }

    }

    function end() {
        stopGame();
        renderer.view.dispatchEvent(new Event(GameEvents.EVENT_END_GAME));
        renderer.view.dispatchEvent(new Event(GameEvents.EVENT_CYCLE_GAME));
        loopSequence = [renderOnce];
    }

    function stopGame() {
        gameData.scene.clear();
    }

    function prepareData() {

        gameData.numItems = 1;
        gameData.currentItem = 0;
        gameData.scene = gameScene;
        gameData.scene.reset();
    }


    function makeScenes() {
        scenesContainer = new Container();
        scenesContainer.position.set(285, 0);
        game.gameContainer.addChild(scenesContainer);

        gameScene = new Scene('gioco', itemsPositionsObject);

    }

    function makeCounter() {
        counter = new ItemsCounter();
        // if (gameData.numItems > 1) {
        game.gameContainer.addChild(counter.container);
        //  }

    }


    function positionGameItems() {
        sprites.btn_gioca.x = 935;
        sprites.btn_gioca.y = 327;
        sprites.btn_gioca.alpha = 0;
    }

    function resetItems() {

    }

    /**
     * GAME LOGIC
     */
    function onAnswerOk(e) {
        renderer.view.dispatchEvent(new Event(GameEvents.GREEN_LIGHT));
        gameData.currentItem++;
        //  counter.setText(gameData.currentItem + "/" + gameData.numItems);

    }

    function onAnswerWrong(e) {
        //  gameData.currentItem++;
        renderer.view.dispatchEvent(new Event(GameEvents.RED_LIGHT));
    }
}


function Scene(sceneName, positions) {
    var name = sceneName;
    this.name = name;
    this.reset = reset;
    this.clear = clear;
    var animating;
    var currentState;
    this.setState = setState;




    var tl = new TimelineMax();
    //
    var container = new Container();
    this.container = container;
    this.container.addChild(game.sprites.fondo_comune);

    var buttonsContainer;

    var currentButton = '';
    var gameIndex = 0;
    var sceneElements = {};


    renderer.view.addEventListener(GameEvents.EVENT_CYCLE_GAME, cycled);


    initScene();

    function initScene() {
        var i, ii;

        var spriteItem;
        var pos;
        game.sprites.fondo_comune.interactive = true;
        game.sprites.fondo_comune.on('pointertap', onbgClick);

        buttonsContainer = new Container();
        buttonsContainer.on('pointertap', onClick);
        buttonsContainer.interactive = true;

        container.addChild(buttonsContainer);
        sceneElements.buttonsContainer = buttonsContainer;
        pos = positions.drop_area;
        spriteItem = new Graphics();
        spriteItem.position.set(pos.x, pos.y);
        spriteItem.name = "drop_area";
        spriteItem.beginFill(0xffc69b);
        spriteItem.lineStyle(0, 0x000000);
        spriteItem.drawRect(0, 0, pos.w, pos.h);
        spriteItem.endFill();
        spriteItem.interactive = true;
        spriteItem.buttonMode = true;
        spriteItem.alpha = 0;
        buttonsContainer.addChild(spriteItem);
        sceneElements.drop_area = spriteItem;



        spriteItem = new Graphics();
        pos = positions.zebra;
        spriteItem.name = "zebra";
        spriteItem.beginFill(0xffc69b);
        spriteItem.lineStyle(0, 0x000000);
        spriteItem.drawRect(0, 0, pos.w, pos.h);
        spriteItem.endFill();
        spriteItem.position.set(pos.x, pos.y);
        spriteItem.interactive = true;
        spriteItem.buttonMode = true;
        buttonsContainer.addChild(spriteItem);
        sceneElements.zebra = spriteItem;
        var points = [49, 393, 61, 376, 62, 345, 55, 333, 54, 316, 19, 278, 19, 247, 14, 207, 2, 173, 4, 131, 20, 78, 21, 65, 29, 27, 43, 9, 63, 3, 102, 4, 128, 21, 145, 36, 130, 56, 127, 65, 130, 84, 134, 86, 158, 93, 179, 105, 183, 119, 160, 138, 147, 145, 140, 150, 126, 150, 115, 150, 101, 150, 78, 144, 91, 154, 112, 163, 138, 158, 171, 146, 198, 143, 215, 144, 244, 157, 263, 179, 265, 214, 253, 258, 249, 290, 267, 301, 270, 314, 266, 353, 264, 371, 256, 382, 230, 385, 222, 376, 246, 365, 246, 335, 246, 324, 228, 313, 216, 299, 210, 299, 205, 316, 219, 328, 212, 343, 210, 355, 209, 378, 210, 387, 206, 396, 203, 399, 193, 407, 169, 405, 180, 392, 187, 381, 178, 338, 132, 317, 121, 305, 122, 313, 129, 327, 122, 340, 130, 375, 140, 386, 110, 389, 112, 369, 105, 333, 100, 320, 96, 296, 88, 287, 73, 290, 73, 308, 80, 322, 75, 341, 80, 360, 83, 376, 78, 386, 73, 396, 49, 393, 49, 393, 54, 393];
        var poly = new PIXI.Polygon(points);
        spriteItem.hitArea = poly;
        spriteItem.alpha = 0;
        //sceneElements.drop_area.mask=sceneElements.zebra ;

        spriteItem = game.sprites.coda;
        spriteItem.name = 'coda';
        pos = positions.coda;
        spriteItem.position.set(pos.x, pos.y);
        buttonsContainer.addChild(spriteItem);
        sceneElements.coda = spriteItem;
        spriteItem.interactive = true;
        spriteItem.buttonMode = true;


        spriteItem = game.sprites.coda_01;
        buttonsContainer.addChild(spriteItem);
        sceneElements.coda_01 = spriteItem;

    }


    function clear() {


    }

    function reset() {
        setState('newLevel');
    }



    function cycled() {
        setState('ready');
    }

    function setState(state) {

        switch (state) {
            case 'newLevel':
                spriteItem = game.sprites.coda;
                pos = positions.coda;
                currentButton = '';
                sceneElements.coda_01.alpha = 0;
                sceneElements.coda.alpha = 1;
                break;
            case 'ready':
                loopSequence = [renderOnce];
                break;
            case 'animating':


                break;
        }
        currentState = state;

    }

    function onbgClick() {
        if (currentState === "ready") {

            setState('animating');
            renderer.view.dispatchEvent(new Event('answerWrong'));
            setTimeout(wrongComplete, 200);
            loopSequence = [renderOnce];
        }
    }
    function onClick(e) {

        if (currentState === "ready") {
            if (e.target.name === 'coda') {
                currentButton = e.target.name;
                sceneElements.coda.alpha = 0.5;
            } else {
                if (currentButton === 'coda') {
                    currentButton = '';
                    var pos = { x: e.data.global.x, y: e.data.global.y };
                    sceneElements.coda_01.position.set(pos.x - 320, pos.y - 30);
                    sceneElements.coda_01.alpha = 1;
                    sceneElements.coda.alpha = 0;

                    //bottone from
                    ok = e.target.name === "zebra";
                    if (ok) {

                        setState('animating');
                        renderer.view.dispatchEvent(new Event('answerOk'));
                        setTimeout(okComplete, 1000);
                    } else {
                        setState('animating');
                        renderer.view.dispatchEvent(new Event('answerWrong'));
                        setTimeout(wrongComplete, 1000);
                    }


                }
            }

        } loopSequence = [renderOnce];
    }


    function okComplete() {

        /*  gameIndex++;
          if (gameIndex < 3) {
              setState('newLevel');
          }*/
        theGame.cycleGame();
        loopSequence = [renderOnce];

    }


    function wrongComplete() {
        // gameIndex++;
        theGame.cycleGame();
        sceneElements.coda_01.alpha = 0;
        sceneElements.coda.alpha = 1;
        //  setState('ready');
        loopSequence = [renderOnce];
    }
}